/* ============
 * Vuex Store
 * ============
 *
 * The store of the application
 *
 * http://vuex.vuejs.org/en/index.html
 */

import Vue from 'vue';
import Vuex from 'vuex';

// Modules
import application from './modules/application';
import adminGroups from './modules/admin-groups';
import adminRules from './modules/admin-rules';
import adminUsers from './modules/admin-users';
import auth from './modules/auth/index';
import campaigns from './modules/campaigns/index';
import chorus from './modules/chorus/index';
import collectors from './modules/collectors';
import documents from './modules/documents/index';
import i18n from './modules/i18n/index';
import masks from './modules/masks';
import organizations from './modules/organizations/index';
import partnerships from './modules/partnerships/index';
import signworkflow from './modules/signWorkflow/index';
import users from './modules/users/index';


Vue.use(Vuex);

const debug = process.env.NODE_ENV !== 'production';

export default new Vuex.Store({
  /**
   * Assign the modules to the store.
   */
  modules: {
    application,
    adminGroups,
    adminRules,
    adminUsers,
    auth,
    campaigns,
    chorus,
    collectors,
    documents,
    i18n,
    masks,
    organizations,
    partnerships,
    signworkflow,
    users,
  },
  /**
   * If strict mode should be enabled.
   */
  strict: debug,
});



// WEBPACK FOOTER //
// ./src/store/index.js